<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog :value="display" max-width="75%" persistent>
    <v-card class="surface lighten-1">
      <v-card-title class="pt-4 pa-0 surface lighten-1 d-block">
        <div class="xtium-title pl-4 pb-2">Supervised Agents</div>
        <v-divider />
        <v-tabs v-model="tab" class="surface lighten-1" background-color="surface lighten-1">
          <v-tab v-once> {{ $t('showColumns') }} </v-tab>
          <v-tab v-once>
            {{ $t('reorderColumns') }}
          </v-tab>
          <v-tab v-once>
            {{ $t('displayAgents') }}
          </v-tab>
          <v-tab v-once>
            {{ $t('filters') }}
          </v-tab>
        </v-tabs>
      </v-card-title>
      <v-divider />

      <v-card-text class="surface pa-0">
        <v-tabs-items v-model="tab" class="surface">
          <v-tab-item class="tab-content">
            <v-checkbox
              v-for="column in shownColumnItems"
              :key="column.value"
              :input-value="column.show"
              :label="$t(`columns.${column.value}`)"
              hide-details
              @change="value => onColumnSelection(value, column.value)"
            ></v-checkbox>
          </v-tab-item>
          <v-tab-item class="tab-content">
            <EcsHeaderReorder :headers="tempItems" :tab="tab" @onColumnReorder="onColumnReorder" />
          </v-tab-item>
          <v-tab-item class="tab-content">
            <v-checkbox
              v-for="agent in agentItems"
              :key="agent.agentId"
              :input-value="agent.isDisplayed"
              :label="agent.agentName"
              hide-details
              @change="value => onAgentSelection(value, agent.agentId)"
            ></v-checkbox>
          </v-tab-item>
          <v-tab-item class="tab-content">
            <EcsFilters :headers="tempItems" :tab="tab" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="restoreDefault">
          <span v-once>{{ $t('restoreDefault') }}</span>
        </v-btn>
        <v-btn color="primary" text @click="dialogClose">
          <span v-once>{{ $t('cancel') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          depressed
          :disabled="isAcceptDisabled"
          @click="() => dialogAccept(tempItems, tempHiddenIds)"
        >
          <span v-once>{{ $t('save') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>

    <EcsConfirmationDialog
      ref="restoreAgentsDefaultConfirmationDialog"
      :title="$t('dialogs.restoreDefault.title')"
      :message="$t('dialogs.restoreDefault.description')"
      :confirm-button-text="$t('accept')"
      :cancel-button-text="$t('cancel')"
    />
  </v-dialog>
</template>

<script>
import EcsHeaderReorder from '@/components/ecs-wallboard-card/ecs-supervised-agents-slide/EcsHeaderReorder';
import EcsFilters from '@/components/ecs-wallboard-card/ecs-supervised-agents-slide/EcsFilters';
import EcsConfirmationDialog from '@/components/ecs-confirmation-dialog/EcsConfirmationDialog';

export default {
  name: 'EcsShowColumns',

  components: { EcsHeaderReorder, EcsFilters, EcsConfirmationDialog },

  props: {
    display: {
      type: Boolean,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    dialogClose: {
      type: Function,
      required: true
    },
    dialogAccept: {
      type: Function,
      required: true
    },
    dialogRestore: {
      type: Function,
      required: true
    },
    agents: {
      type: Array,
      required: true
    },
    hiddenIds: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      tempItems: [],
      tab: 0,
      windowsGrid: null,
      tempHiddenIds: [],
      isAcceptDisabled: false
    };
  },

  computed: {
    agentItems() {
      return this.agents.map(({ agentId, agentName }) => {
        return {
          agentId,
          agentName,
          isDisplayed: !this.tempHiddenIds.includes(agentId)
        };
      });
    },
    shownColumnItems() {
      return this.tempItems.filter(tempItem => tempItem.value !== 'agentName');
    }
  },

  watch: {
    display(newValue) {
      if (newValue) {
        this.tempItems = structuredClone(this.items);
        this.tempHiddenIds = structuredClone(this.hiddenIds);
        this.tempItems.sort((a, b) => a.columnIndex - b.columnIndex);
      }
    }
  },
  mounted() {
    this.$root.$on('disable-accept', this.disableAccept);
    this.$root.$on('enable-accept', this.enableAccept);
  },
  methods: {
    onColumnSelection(newValue, headerValue) {
      const headerIndex = this.tempItems.findIndex(i => i.value === headerValue);
      this.tempItems[headerIndex].show = newValue;
    },

    onColumnReorder(newOrder) {
      newOrder.forEach((item, index) => {
        const headerIndex = this.tempItems.findIndex(header => header.value === item);
        this.tempItems[headerIndex].columnIndex = index;
        this.tempItems.sort((a, b) => a.columnIndex - b.columnIndex);
      });
    },

    onAgentSelection(checked, agentId) {
      if (checked) {
        this.tempHiddenIds = this.tempHiddenIds.filter(currentAgentId => agentId !== currentAgentId);
      } else {
        this.tempHiddenIds.push(agentId);
      }
    },

    disableAccept() {
      this.isAcceptDisabled = true;
    },
    enableAccept() {
      this.isAcceptDisabled = false;
    },
    async restoreDefault() {
      const confirmed = await this.$refs.restoreAgentsDefaultConfirmationDialog.open();
      if (confirmed) {
        this.dialogRestore();
      }
    }
  }
};
</script>

<style scoped>
.tab-content {
  height: 400px;
  overflow-y: auto;
  padding-left: 20px;
}
</style>
